import { render, staticRenderFns } from "./alarmStatistics.vue?vue&type=template&id=5356128e"
import script from "./alarmStatistics.vue?vue&type=script&lang=js"
export * from "./alarmStatistics.vue?vue&type=script&lang=js"
import style0 from "./alarmStatistics.vue?vue&type=style&index=0&id=5356128e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports